import React, { useRef, useEffect, useState } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import Actions from "./Actions";

export default function SingleTableRow({
  index,
  editIndex,
  saved,
  currentFocus,
  validate,
  setSaved,
  setEditIndex,
  rowCopy,
  setRowCopy,
  columns,
  options,
  provided,
  row,
}) {
  const [shiftDown, setShiftDown] = useState(false);

  function handleChange(e) {
    setRowCopy({
      ...rowCopy,
      [options.singleRow]: e.target.value,
    });
  }

  function handleBlur(e) {
    if (e.relatedTarget?.id === e.target?.id) e.stopPropagation();

    if (e.relatedTarget?.id === "button") return;

    if (e.relatedTarget?.id.includes("cell")) {
      // console.log("related");
      e.relatedTarget.focus();
    } else {
      validate(row);
    }
  }

  function handleClick(e) {
    if (options.editable === false) return;

    if (editIndex.rowIndex === index) {
      e.stopPropagation();
    }

    setEditIndex({
      rowIndex: index,
      columnIndex: 0,
    });
  }

  function handleKeyUp(e) {
    if (e.key === "Shift") {
      // console.log("shift off");

      setShiftDown(false);
    }

    if (e.key === "Enter" && !shiftDown) {
      validate(row);

      options?.newRecord?.(setEditIndex, setRowCopy);
    }
  }

  function handleKeyDown(e) {
    if (e.key === "Enter" && !shiftDown) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }

    if (e.key === "Shift") {
      // console.log("shift");

      setShiftDown(true);
    }
  }

  return (
    <TableRow
      key={index}
      sx={{
        display: "flex",
        backgroundColor: "#f7efd3",
        justifyContent: "spaceAround",
        "&:last-child td, &:last-child th": {
          border: 0,
        },
      }}
      onClick={() => {
        setRowCopy(row);
      }}
    >
      {options.dragable && (
        <TableCell sx={{ width: "18px" }} {...provided.dragHandleProps} handle>
          <DragHandleIcon />
        </TableCell>
      )}

      <TableCell
        sx={{
          minWidth: "calc(100% - 202px)",
          // minHeight: "50px",
          width: "calc(100% - 202px)",
        }}
        component="th"
        scope="row"
        key={index}
        onClick={(e) => handleClick(e)}
      >
        {editIndex.rowIndex === index && options.editable !== false && (
          <TextField
            value={row[options.singleRow]}
            onChange={(e) => handleChange(e)}
            multiline
            error={
              columns.find((item) => item.id === options.singleRowId)
                ?.required === true && saved === false
            }
            size="small"
            sx={{ width: "100%" }}
            autoFocus={true}
            id={`cell${index}`}
            inputRef={(el) => (currentFocus.current[0] = el)}
            onKeyUp={(e) => handleKeyUp(e)}
            onKeyDown={(e) => handleKeyDown(e)}
            onBlur={(e) => handleBlur(e)}
          />
        )}

        {editIndex.rowIndex !== index && row[options.singleRow]}
      </TableCell>

      <Actions
        editIndex={editIndex}
        index={index}
        validate={validate}
        row={row}
        options={options}
        setSaved={setSaved}
        rowCopy={rowCopy}
      />
    </TableRow>
  );
}
